import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { colors } from "../../../styles/utils/vars";
import { StyledFieldWrapper, StyledInput } from "../Field/StyledField";
import { TypographyBase } from "../Typography/Typography";
export const cssRange = "cssRange_ccdvu46";
export const StyledRangeInput = /*#__PURE__*/styled('div')({
  name: "StyledRangeInput",
  class: "StyledRangeInput_s1ulr3oh"
});
export const StyledRangeContainer = /*#__PURE__*/styled('div')({
  name: "StyledRangeContainer",
  class: "StyledRangeContainer_s1o7t2i3"
});
export const StyledRangeWrapper = /*#__PURE__*/styled('div')({
  name: "StyledRangeWrapper",
  class: "StyledRangeWrapper_s93feta"
});

require("./StyledRange.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledRange.tsx");